import { useState, type ReactNode } from "react";

import { browserSupportsBrian } from "../interaction/supported";

export interface BrowserGateProps {
  children: ReactNode;
}

/**
 * Renders the app only on browsers with modal `<dialog>` and the Popover API,
 * which every Brian overlay depends on; everything else gets a dead-end notice.
 * The check runs once on first render, so mount this inside a client-rendered tree.
 */
export function BrowserGate({ children }: BrowserGateProps) {
  const [supported] = useState(browserSupportsBrian);

  if (supported) return <>{children}</>;

  return (
    <div className="flex min-h-dvh w-full items-center justify-center bg-desk p-6">
      <div className="max-w-md rounded-sheet bg-card px-8 py-7 text-left shadow-float">
        <p className="text-annotation-caps text-annotation">
          brian - compatibility
        </p>
        <h1 className="mt-3 font-display text-2xl font-semibold text-ink">
          I need a newer browser.
        </h1>
        <p className="mt-3 font-body text-sm leading-relaxed text-ink-body">
          This one is missing things I rely on to do my job. Update Chrome,
          Edge, Safari, or Firefox and I will take it from here.
        </p>
      </div>
    </div>
  );
}
